<template>
  <div>
    <Form
      ref="formValidate"
      :model="formValidate"
      :rules="ruleValidate"
      :label-width="100"
    >
      <FormItem label="类型"  prop="taskType">
        <Select v-model="formValidate.taskType">
          <Option
            v-for="item in taskTypes"
            :value="item.id"
            :key="item.id"
            >{{ item.name}}</Option
          >
        </Select>
      </FormItem>

      <FormItem label="平台"  prop="liveType">
        <Select v-model="formValidate.liveType" @on-change="liveTypeChange">
          <Option
            v-for="item in liveTypes"
            :value="item.id"
            :key="item.id"
            >{{ item.name}}</Option
          >
        </Select>
      </FormItem>

      <FormItem label="搜索词" prop="search" v-if="formValidate.taskType==5">
        <Input v-model="formValidate.search" placeholder="请输入搜索词"></Input>
      </FormItem>
      
      <FormItem label="处理多少条结果" prop="result_count" v-if="formValidate.taskType==5">
        <Input v-model="formValidate.result_count" placeholder="请输入数量" inputmode="numeric"></Input>
      </FormItem>

      <FormItem label="视频"  prop="video" v-if="formValidate.taskType==4">
        <Select v-model="formValidate.video">
          <Option
            v-for="item in videoIds"
            :value="item.id"
            :key="item.id"
            >{{ item.name}}</Option
          >
        </Select>
      </FormItem>
      
      <FormItem label="角色" v-if="formValidate.taskType==4">
        <RadioGroup v-model="formValidate.comment_type">
        <Radio label="黑粉"></Radio>
        <Radio label="白粉"></Radio>
        </RadioGroup>
      </FormItem>
      
      <!-- <FormItem label="私信" prop="letter_str" v-if="formValidate.taskType==6">
        <Input v-model="formValidate.letter_str" placeholder="请输入话术"></Input>
      </FormItem> -->

      <FormItem label="目标"  prop="comment" v-if="formValidate.taskType==2">
        <Select v-model="formValidate.comment">
          <Option
            v-for="item in comments"
            :value="item.id"
            :key="item.id"
            >{{ item.name}}</Option
          >
        </Select>
      </FormItem>

      <FormItem label="方式" v-if="formValidate.taskType==2">
        <RadioGroup v-model="formValidate.user_type">
        <Radio label="具体的人"></Radio>
        <Radio label="选择人数"></Radio>
        </RadioGroup>
      </FormItem>

      <FormItem label="执行人" v-if="formValidate.user_type=='具体的人'">
        <Transfer
          :list-style="listStyle"
          :titles="['未选', '已选']"
          :data="userIds"
          :target-keys="formValidate.users"
          filterable
          :filter-method="filterMethod"
          @on-change="handleChange"
        ></Transfer>
      </FormItem>

      <!-- <FormItem label="客户"  prop="custmoer" v-if="formValidate.taskType==6">
        <Select v-model="formValidate.custmoer">
          <Option
            v-for="item in custmoers"
            :value="item.id"
            :key="item.id"
            >{{ item.name}}</Option
          >
        </Select>
      </FormItem> -->

      <FormItem label="执行人" v-else>
        <RadioGroup v-model="formValidate.user_number" >
          <Radio label="%20"></Radio>
          <Radio label="%50"></Radio>
          <Radio label="%80"></Radio>
          <Radio label="%100"></Radio>
        </RadioGroup>
      </FormItem>

      <FormItem style="text-align: right">
        <Button @click="handleReset('formValidate')">重置</Button>
        <Button
          type="primary"
          @click="handleSubmit('formValidate')"
          style="margin-left: 8px"
          >提交</Button
        >
      </FormItem>
    </Form>
  </div>
</template>

<script>
import user from '@/store/module/user';
import params from '../argu-page/params.vue'
import {getStrategyUser, listComment, videoList} from "@/api/data";
export default {
  components: { params },
  props: {
    resetFlag: {
      type: Boolean,
      default: false
    },
    editData: {
      type: Object,
      default: () => {}
    },
    edit: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      listStyle:{
        width: '300px'
      },
      liveTypes: [],
      taskTypes:[],
      comments:[],
      userIds:[],
      videoIds:[],
      formValidate: {
        id: '',
        taskType:'',
        liveType:'',
        comment:'',
        users: [],
        user_number:'%20',
        user_type:'具体的人',
        search:'',
        result_count:10,
        comment_type:"黑粉",
        video_link:"",
      },
      ruleValidate: {
        taskType: [
          {
            required: true,
            message: '选择任务类型',
            trigger: 'change'
          }
        ],
        search: [
          {
            required: true,
            message: '关键字不能为空',
            trigger: 'blur'
          }
        ],
        video_link: [
          {
            required: true,
            message: '视频地址不能为空',
            trigger: 'blur'
          }
        ],
        liveType: [
          {
            required: true,
            message: '选择直播平台',
            trigger: 'change'
          }
        ],
        comment: [
          {
            required: true,
            message: '选择目标评论',
            trigger: 'change'
          }
        ], users: [
          {
            required: true,
            message: '选择执行人'
          }
        ]
        
      }
    }
  },
  watch: {
    resetFlag (resetFlag) {
      this.handleReset('formValidate')
    }
  },
  methods: {
    liveTypeChange(value){

      if (value == undefined){
        return
      }

      // 获取执行人
      this.getStrategyUser(value)

      if (this.formValidate.taskType == 2){ // 如果是点赞任务，
        this.listComment(value)

      }else if (this.formValidate.taskType == 4){ // 如果是评论任务
        this.getVideoList(value)
      }

    }, getVideoList(value){
      var params = {
        live_id: value,
        status: 1
      }

      videoList(params).then((res) => {
        var videoList = res.data.data.records;
        var data = new Array()
        for (var i = 0; i < videoList.length; i++) {
          var labelName = videoList[i].username + ":" + videoList[i].video_title
          data[i] = { id: videoList[i].id.toString(), name: labelName }
        }
        this.videoIds = data
      });

    }, listComment(value){

      var params = {
          type: 1,
          live_id: value
        }
        listComment(params).then((res) => {
          var listComment = res.data.data.records;
          var data = new Array()
          for (var i = 0; i < listComment.length; i++) {
            var labelName = listComment[i].username + ":" + listComment[i].content
            data[i] = { id: listComment[i].id.toString(), name: labelName }
          }
          this.comments = data
        });


    },getStrategyUser(value){

      var params = {
        live_id: value
      }
      getStrategyUser(params).then((res) => {
        var users = res.data.data.records;
        var data = new Array()
        for (var i = 0; i < users.length; i++) {
          var user = users[i]
          if (!user._black){
            data.push({key: user.dy_id, label: user.username})
          }
      }
        this.userIds = data
      });


    },setTaskType (classify_list) {
      var data = new Array()
      for (var i = 0; i < classify_list.length; i++) {
        data[i] = { id: classify_list[i].id.toString(), name: classify_list[i].name }
      }
      this.taskTypes = data

    },  setLiveType (classify_list) {
      var data = new Array()
      for (var i = 0; i < classify_list.length; i++) {
        data[i] = { id: classify_list[i].id.toString(), name: classify_list[i].name }
      }
      this.liveTypes = data

    },filterMethod (data, query) {
      return data.label.indexOf(query) > -1
    },
    handleChange (newTargetKeys) {
      this.formValidate.users = newTargetKeys
    },

    handleSubmit (name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.$emit('on-ok', this.formValidate)
        } else {
          this.$Message.error('失败!')
        }
      })
    },
    handleReset (name) {
      this.$refs[name].resetFields()
    }
  }
}
</script>
